import { createActions } from "redux-actions";

export enum NotificationsActionsType {
  GET_NOTIFICATIONS_INFO = "GET_NOTIFICATIONS_INFO",
  GET_NOTIFICATIONS_INFO_SUCCESS = "GET_NOTIFICATIONS_INFO_SUCCESS",
  GET_NOTIFICATIONS_INFO_FAILURE = "GET_NOTIFICATIONS_INFO_FAILURE",
  GET_NOTIFICATIONS_INFO_IDLE = "GET_NOTIFICATIONS_INFO_IDLE",
  GET_ITEMS_NOTIFICATIONS_CARD = "GET_ITEMS_NOTIFICATIONS_CARD",
  GET_ITEMS_NOTIFICATIONS_CARD_FAILURE = "GET_ITEMS_NOTIFICATIONS_CARD_FAILURE",
}

const { getNotificationsInfo, getNotificationsInfoSuccess, getNotificationsInfoFailure, getNotificationsInfoIdle, getItemsNotificationsCard, getItemsNotificationsCardFailure } =
  createActions(
    NotificationsActionsType.GET_NOTIFICATIONS_INFO,
    NotificationsActionsType.GET_NOTIFICATIONS_INFO_SUCCESS,
    NotificationsActionsType.GET_NOTIFICATIONS_INFO_FAILURE,
    NotificationsActionsType.GET_NOTIFICATIONS_INFO_IDLE,
    NotificationsActionsType.GET_ITEMS_NOTIFICATIONS_CARD,
    NotificationsActionsType.GET_ITEMS_NOTIFICATIONS_CARD_FAILURE
  );

export { getNotificationsInfo, getNotificationsInfoSuccess, getNotificationsInfoFailure, getNotificationsInfoIdle, getItemsNotificationsCard, getItemsNotificationsCardFailure };
